function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.942 3.664c.038.108.058.222.058.336v14.3c0 .446-.046.607-.134.77-.087.163-.215.291-.378.378-.162.088-.324.134-.77.134H2.282c-.446 0-.607-.046-.77-.134-.163-.087-.291-.215-.378-.378-.088-.163-.134-.324-.134-.77V4c0-.552.448-1 1-1 .114 0 .228.02.336.058L6.5 4.543h11l4.164-1.485c.52-.185 1.092.086 1.278.606zM20.8 5.701l-2.561.914c-.178.064-.363.104-.55.12l-.189.008h-11c-.189 0-.377-.024-.559-.072l-.18-.056L3.2 5.702v11.68h17.6V5.701zM8 8.677v7H6v-7h2zm5 0v7h-2v-7h2z"
});

function SvgIconSpaceContainer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpaceContainer);
export default __webpack_public_path__ + "static/media/icon-spaceContainer.9cbe8d5a.svg";
export { ForwardRef as ReactComponent };